/**
 * Corrige o erro benigno "ResizeObserver loop completed with undelivered notifications".
 *
 * A causa é um callback de ResizeObserver que altera o layout e dispara outro resize no
 * mesmo frame (comum em libs que observam tamanho: UI5/Fiori, charts, tabelas). O patch
 * envolve os callbacks em requestAnimationFrame, adiando 1 frame e quebrando o loop —
 * eliminando a notificação não-entregue na origem (em vez de só esconder o erro).
 *
 * Importar uma vez no boot (index.tsx), antes de renderizar o app.
 */
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;

  const debounce = (callback: ResizeObserverCallback): ResizeObserverCallback => {
    let frame = 0;
    return (entries, observer) => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => callback(entries, observer));
    };
  };

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super(debounce(callback));
    }
  };
}

export {};
